{
    "TeamsAuth_UserIntro": "Ciao **{}**,",
    "TeamsAuth_UserIntro_2": "Akixi for MS Teams richiede l'accesso al vostro Microsoft Entra Tenant.",
    "TeamsAuth_AdminConsent": "Concessione del consenso amministrativo",
    "TeamsAuth_Authorise": "Autorizzare",
    "TeamsAuth_ConsentedMessage": "Consenso amministrativo accordato, fare clic su Autorizza per proseguire",
    "TeamsAuth_AuthorisedMessage": "Autorizzazione concessa",
    "TeamsAuth_Decline": "Declino",
    "TeamsAuth_Error_Unknown": "Si è verificato un errore non riconosciuto. Riprovare. Se il problema persiste, contattare l'amministratore di sistema.",
    "NAME": "TeamsAuth",
    "TeamsAuth_Authoriser_Select_Title": "Quali utenti desideri sincronizzare dal tuo tenant Microsoft Entra?",
    "TeamsAuth_Authoriser_Select_Options_Tenant": "Tutti gli utenti applicabili dal tenant",
    "TeamsAuth_Authoriser_Select_Options_SecurityGroups": "Solo gruppi di sicurezza selezionati",
    "TeamsAuth_SecurityGroups_Loader_Title_1": "Ottenere gruppi di sicurezza",
    "TeamsAuth_SecurityGroups_Loader_Title_2": "Non dovrebbe volerci molto, abbiate pazienza...",
    "TeamsAuth_SecurityGroups_Title": "Seleziona i tuoi gruppi di sicurezza",
    "TeamsAuth_SecurityGroups_SecurityGroup_NothingToSee": "Nessun gruppo di sicurezza trovato...",
    "TeamsAuth_SecurityGroups_SecurityGroup": "[ID: {}]",
    "TeamsAuth_SecurityGroups_Note": "Nota: i gruppi di sicurezza possono essere aggiornati in seguito",
    "TeamsAuth_SecurityGroups_SyncAndClose": "Sincronizza e chiudi",
    "TeamsAuth_SecurityGroups_NoSecurityGroups": "Sincronizza l'intero tenant"
}